<div class="route-form-container">
    <app-select-route-form />
    <app-route-form-options-panels />
    <div class="buttons-row">
        <button aria-label="New route button" class="clean-button" [disabled]="loading()" (click)="cleanForms()" mat-raised-button color="white">{{'routeForm.newRoute' | transloco}}</button>
        <button aria-label="Search button" class="search-button" [disabled]="isSearchButtonDisabled() || loading()" (click)="searchButtonClicked()" mat-raised-button color="primary">{{'routeForm.search' | transloco}}</button>
    </div>
</div>